export const SET_WSCORE_WHEEL_ACTIVE = 'wscoreWheel/SET_WSCORE_WHEEL_ACTIVE';

export function setWScoreWheelActive(active) {
  return {
    type: SET_WSCORE_WHEEL_ACTIVE,
    payload: { active }
  };
}
